import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShoppingBag, Package, Truck, CreditCard } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MerchandisingPage = () => {
  // Produits merchandising
  const products = [
    {
      id: 1,
      name: "Sweat à Capuche - Logo G.Lley'",
      price: "45€",
      image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=500&q=80",
      description: "Sweat confortable en coton bio avec logo brodé",
      sizes: ["S", "M", "L", "XL", "XXL"],
      popular: true
    },
    {
      id: 2,
      name: "T-Shirt Signature",
      price: "25€",
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&q=80",
      description: "T-shirt premium avec design exclusif Gail Lleyton",
      sizes: ["S", "M", "L", "XL", "XXL"]
    },
    {
      id: 3,
      name: "Casquette Snapback",
      price: "30€",
      image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=500&q=80",
      description: "Casquette ajustable avec broderie logo",
      sizes: ["Unique"]
    },
    {
      id: 4,
      name: "Totebag Exclusif",
      price: "15€",
      image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=500&q=80",
      description: "Sac en toile réutilisable design limité",
      sizes: ["Unique"]
    },
    {
      id: 5,
      name: "Stickers Pack",
      price: "8€",
      image: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=500&q=80",
      description: "Pack de 5 stickers avec designs variés",
      sizes: ["Unique"]
    },
    {
      id: 6,
      name: "Poster Collector A2",
      price: "20€",
      image: "https://images.unsplash.com/photo-1594834226097-b0b165d3a139?w=500&q=80",
      description: "Poster haute qualité format A2 (42x59.4cm)",
      sizes: ["A2"]
    }
  ];

  const features = [
    {
      icon: Package,
      title: "Qualité Premium",
      description: "Produits de qualité, soigneusement sélectionnés"
    },
    {
      icon: Truck,
      title: "Livraison",
      description: "Expédition et délais variables selon le produit et le pays"
    },
    {
      icon: CreditCard,
      title: "Paiement Sécurisé",
      description: "Transactions 100% sécurisées"
    }
  ];

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-neutral-900 to-black">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            Retour
          </Link>

          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-3 mb-6">
              <ShoppingBag size={48} className="text-rose-500" />
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-bold uppercase text-white mb-6 tracking-wide">
              Merchandising Exclusif
            </h1>
            <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
              Découvrez ma collection exclusive de vêtements et accessoires. 
              Chaque produit est créé avec soin pour représenter l'univers artistique de Gail Lleyton.
            </p>
          </div>

          {/* Features */}
          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="bg-neutral-900 border border-neutral-800 rounded-xl p-6 text-center hover:border-rose-500/50 transition-all duration-300"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-rose-800 to-violet-800 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon size={28} className="text-white" />
                  </div>
                  <h3 className="text-white font-bold mb-2">{feature.title}</h3>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Products Grid - Coming Soon */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <h2 className="font-display text-4xl font-bold uppercase text-white mb-12 text-center tracking-wide">
            Collection Gail Lleyton
          </h2>
          
          {/* Coming Soon Message */}
          <div className="max-w-3xl mx-auto text-center py-16">
            <div className="bg-gradient-to-br from-neutral-900 to-neutral-800 border border-rose-500/30 rounded-2xl p-12">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Boutique en préparation
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                La collection exclusive Gail Lleyton arrive très bientôt.<br/>
                Vêtements, accessoires et objets créatifs sont en cours de finalisation pour vous offrir une expérience unique.
              </p>
              <p className="text-rose-400 font-semibold text-xl mb-8">
                📦 Lancement prévu prochainement
              </p>
              <p className="text-gray-400 mb-8">
                Pour recevoir une alerte dès le lancement, contactez-nous !
              </p>
              <a
                href="mailto:Shop@GailLleyton.com?subject=Alerte%20lancement%20boutique"
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full font-bold uppercase text-sm tracking-wider hover:scale-105 transition-transform duration-300"
              >
                <ShoppingBag size={20} />
                Nous Contacter
              </a>
            </div>
          </div>

          {/* Hidden products for now */}
          <div className="hidden grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div
                key={product.id}
                className={`group relative bg-gradient-to-br from-neutral-900 to-neutral-800 border rounded-2xl overflow-hidden hover:border-rose-500/50 transition-all duration-300 hover:transform hover:-translate-y-2 ${
                  product.popular ? 'ring-2 ring-rose-500' : 'border-neutral-700'
                }`}
              >
                {product.popular && (
                  <div className="absolute top-4 right-4 z-20 px-4 py-1 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full text-xs uppercase tracking-wider font-semibold shadow-lg">
                    Populaire
                  </div>
                )}

                {/* Image */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent"></div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-gray-400 text-sm mb-4">{product.description}</p>

                  {/* Sizes */}
                  <div className="mb-4">
                    <p className="text-gray-500 text-xs mb-2">Tailles disponibles:</p>
                    <div className="flex flex-wrap gap-2">
                      {product.sizes.map((size, idx) => (
                        <span
                          key={idx}
                          className="px-3 py-1 bg-neutral-800 text-white text-xs rounded-full border border-neutral-700"
                        >
                          {size}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Price & CTA */}
                  <div className="flex items-center justify-between pt-4 border-t border-neutral-700">
                    <div className="text-2xl font-bold text-white">{product.price}</div>
                    <a
                      href={`mailto:contact@GailLleyton.com?subject=${encodeURIComponent('Commande: ' + product.name)}`}
                      onClick={(e) => e.stopPropagation()}
                      className="px-6 py-2 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full text-sm font-semibold uppercase tracking-wider hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-rose-500/50"
                    >
                      Commander
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-b from-black to-neutral-900">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Une Question sur un Produit ?
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Contactez-moi pour plus d'informations sur les produits, les tailles ou les commandes personnalisées
          </p>
          <a
            href="mailto:Shop@GailLleyton.com?subject=Question%20Merchandising"
            onClick={(e) => e.stopPropagation()}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-black rounded-full font-bold uppercase text-sm tracking-wider hover:scale-105 transition-transform duration-300"
          >
            <ShoppingBag size={20} />
            Nous Contacter
          </a>
          
          <div className="mt-12 p-6 bg-neutral-900 border border-neutral-800 rounded-xl">
            <h3 className="text-white font-semibold mb-4">Informations Pratiques</h3>
            <div className="text-gray-400 text-sm space-y-2">
              <p>📦 Expédition et délais variables selon le produit et le pays</p>
              <p>🇫🇷 Livraison gratuite en France à partir de 50€</p>
              <p>💳 Paiement par virement bancaire ou PayPal</p>
              <p>↩️ Retour possible sous 14 jours (produit non porté)</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MerchandisingPage;
